import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b9d5fa9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " tips_and_updates ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info" }, " A word, an idiom, even a prepositional phrase and most importantly whatever you wish to insert ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " tips_and_updates ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info" }, " An explanation of what a word means ", -1))
const _hoisted_6 = { class: "added-definition-action-buttons" }
const _hoisted_7 = { class: "added-definition-contents" }
const _hoisted_8 = { class: "overflowed-content capitalize" }
const _hoisted_9 = {
  key: 1,
  class: "material-icons add-more"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " tips_and_updates ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info" }, " It is possible to save a vocabulary without a definition in draft mode ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_firecracker_header = _resolveComponent("firecracker-header")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_add_linker_words = _resolveComponent("add-linker-words")!
  const _component_add_generic_notes = _resolveComponent("add-generic-notes")!
  const _component_add_generic_external_links = _resolveComponent("add-generic-external-links")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!
  const _component_add_definition = _resolveComponent("add-definition")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isInDefinition())
      ? (_openBlock(), _createBlock(_component_ion_page, _normalizeProps(_mergeProps({ key: 0 }, _ctx.$attrs)), {
          default: _withCtx(() => [
            _createVNode(_component_firecracker_header, {
              "header-title": _ctx.headerTitle,
              "content-id": "add-vocabulary",
              "menu-id": "add-vocabulary-menu",
              type: "MANUAL_BACK",
              "manual-back-icon-handler": _ctx.back
            }, null, 8, ["header-title", "manual-back-icon-handler"]),
            _createVNode(_component_ion_content, {
              fullscreen: true,
              id: "add-vocabulary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "display-flex ion-justify-content-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      sizeXs: "12",
                      sizeSm: "12",
                      sizeMd: "10",
                      sizeLg: "8",
                      sizeXl: "8"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isLoading)
                          ? (_openBlock(), _createBlock(_component_spinner, { key: 0 }))
                          : _createCommentVNode("", true),
                        (!_ctx.isLoading)
                          ? (_openBlock(), _createElementBlock("view", _hoisted_1, [
                              _createVNode(_component_ion_card, { class: "margin-top-unset" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card_header, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_card_title, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Word ")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_card_subtitle, { class: "tips" }, {
                                        default: _withCtx(() => [
                                          _hoisted_2,
                                          _hoisted_3
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_card_content, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_item, {
                                        lines: "none",
                                        class: "vocab-upsert-item"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_textarea, {
                                            "auto-grow": true,
                                            inputmode: "text",
                                            autocapitalize: "sentences",
                                            placeholder: "Type something",
                                            value: _ctx.word,
                                            onIonChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setWord($event.detail.value as string)))
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_card, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card_header, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_card_title, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Definitions ")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_card_subtitle, { class: "tips" }, {
                                        default: _withCtx(() => [
                                          _hoisted_4,
                                          _hoisted_5
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_card_content, { class: "added-definition-card-content" }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.definitions, (definition, index) => {
                                        return _withDirectives((_openBlock(), _createElementBlock("div", {
                                          key: definition.id,
                                          class: "added-definition-container"
                                        }, [
                                          _createElementVNode("div", _hoisted_6, [
                                            _createVNode(_component_ion_button, {
                                              color: "warning",
                                              size: "small",
                                              shape: "round",
                                              fill: "clear",
                                              strong: true,
                                              onClick: ($event: any) => (_ctx.removeDefinition(index))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_font_awesome_icon, { icon: _ctx.faMinusCircle }, null, 8, ["icon"])
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]),
                                            _createVNode(_component_ion_button, {
                                              color: "success",
                                              size: "small",
                                              shape: "round",
                                              fill: "clear",
                                              strong: true,
                                              onClick: ($event: any) => (_ctx.updateDefinition(index))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_font_awesome_icon, { icon: _ctx.faPencilAlt }, null, 8, ["icon"])
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"])
                                          ]),
                                          _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("span", _hoisted_8, _toDisplayString(definition.meaning), 1)
                                          ])
                                        ])), [
                                          [_vShow, !_ctx.isLoading && _ctx.definitions.length]
                                        ])
                                      }), 128))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_card_content, { class: "add-definition-button-container" }, {
                                    default: _withCtx(() => [
                                      (!_ctx.isLoading)
                                        ? (_openBlock(), _createBlock(_component_ion_button, {
                                            key: 0,
                                            color: "success",
                                            size: "large",
                                            shape: "round",
                                            fill: "clear",
                                            strong: true,
                                            onClick: _ctx.onAddingDefinition
                                          }, {
                                            default: _withCtx(() => [
                                              (!_ctx.definitions.length)
                                                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                                    key: 0,
                                                    icon: _ctx.faPlusCircle
                                                  }, null, 8, ["icon"]))
                                                : _createCommentVNode("", true),
                                              (_ctx.definitions.length)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, " plus_one "))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_add_linker_words, {
                                ref: "AddLinkerWordsRef",
                                "existing-linker-words": _ctx.linkerWords
                              }, null, 8, ["existing-linker-words"]),
                              _createVNode(_component_add_generic_notes, {
                                ref: "AddGenericNotesRef",
                                "existing-generic-notes": _ctx.genericNotes
                              }, null, 8, ["existing-generic-notes"]),
                              _createVNode(_component_add_generic_external_links, {
                                ref: "AddGenericExternalLinksRef",
                                "existing-generic-external-links": _ctx.genericExternalLinks
                              }, null, 8, ["existing-generic-external-links"]),
                              _createVNode(_component_ion_card, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card_header, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_card_title, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Draft ")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_card_subtitle, { class: "tips" }, {
                                        default: _withCtx(() => [
                                          _hoisted_10,
                                          _hoisted_11
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_card_content, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_toggle, {
                                        class: "draft-toggle",
                                        "area-label": "Save the vocabulary as draft",
                                        checked: _ctx.isDraft,
                                        onIonChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setIsDraft($event.target.checked)))
                                      }, null, 8, ["checked"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_row, { class: "buttons-container" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, {
                                    sizeXs: "6",
                                    sizeSm: "4",
                                    sizeMd: "2",
                                    sizeLg: "2",
                                    sizeXl: "2",
                                    class: "cancel-button-container"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_button, {
                                        fill: "outline",
                                        color: "warning",
                                        expand: "block",
                                        class: "cancel-button",
                                        onClick: _ctx.back
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Cancel ")
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_col, {
                                    sizeXs: "6",
                                    sizeSm: "4",
                                    sizeMd: "2",
                                    sizeLg: "2",
                                    sizeXl: "2",
                                    class: "save-button-container"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_button, {
                                        color: "success",
                                        expand: "block",
                                        class: "save-button",
                                        disabled: _ctx.disableSaveButton,
                                        onClick: _ctx.persist
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Save ")
                                        ]),
                                        _: 1
                                      }, 8, ["disabled", "onClick"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 16))
      : _createCommentVNode("", true),
    (_ctx.isInDefinition())
      ? (_openBlock(), _createBlock(_component_ion_page, _normalizeProps(_mergeProps({ key: 1 }, _ctx.$attrs)), {
          default: _withCtx(() => [
            _createVNode(_component_add_definition, {
              word: _ctx.word,
              "vocabulary-id": _ctx.id,
              definition: _ctx.goingToBeUpdatedDefinition,
              "on-coming-back-to-vocab": _ctx.onComingBackToVocab,
              "on-cancelling-adding-definition": _ctx.onCancellingAddingDefinition
            }, null, 8, ["word", "vocabulary-id", "definition", "on-coming-back-to-vocab", "on-cancelling-adding-definition"])
          ]),
          _: 1
        }, 16))
      : _createCommentVNode("", true)
  ], 64))
}